<template>
  <div v-if="marker.length">
    <v-map :zoom="zoom" :center="center">
      <v-tilelayer :url="url"/>
      <v-marker
        ref="origin"
        :lat-lng="origin.marker"/>
      <v-marker
        v-for="m in marker"
        :key="m.address"
        :lat-lng="m.marker"/>
    </v-map>
  </div>
</template>

<script>
  import L from 'leaflet';
  import { LMap, LTileLayer, LMarker, LPopup, LPolygon, LCircle } from 'vue2-leaflet';

  export default {
    name: 'leaflet',
    components: {
      'v-map': LMap,
      'v-tilelayer': LTileLayer,
      'v-marker': LMarker,
      'v-popup': LPopup,
      'v-polygon': LPolygon,
      'v-circle': LCircle,
    },
    props: {
      center: {
        type: Array,
        default() {
          return [0, 0];
        },
      },
      zoom: {
        type: Number,
        default: 12,
        require: false,
      },
      url: {
        type: String,
        default: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
        require: false,
      },
      marker: {
        type: Array,
        default() {
          return [];
        },
        require: true,
      },
      origin: {
        type: Object,
        default: {},
        require: true,
      },
    },
    data() {
      return {
        icons: {
          iconRetinaUrl: 'https://unpkg.com/leaflet@1.2.0/dist/images/marker-icon-2x.png',
          iconUrl: 'https://unpkg.com/leaflet@1.2.0/dist/images/marker-icon.png',
          shadowUrl: 'https://unpkg.com/leaflet@1.2.0/dist/images/marker-shadow.png',
        },
      };
    },
    created() {
      /* eslint no-underscore-dangle: 0 */
      delete L.Icon.Default.prototype._getIconUrl;

      const { iconRetinaUrl, iconUrl, shadowUrl } = this.icons;
      L.Icon.Default.imagePath = '';
      L.Icon.Default.mergeOptions({
        iconRetinaUrl,
        iconUrl,
        shadowUrl,
      });
    },
    mounted() {
      this.$refs.origin.$el.style.filter = 'saturate(8)';
    },
  };
</script>
<style lang="sass">
  @import "~leaflet/dist/leaflet.css";

  .leaflet-control-container
    height: 500px;
</style>



// WEBPACK FOOTER //
// src/components/BaseTracking.vue